import api from "!../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.95.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.95.0/node_modules/css-loader/dist/cjs.js??clonedRuleSet-3.use[1]!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.47_babel-core@7.0.0-bridge.0_@babel+core@7.20.12__cs_dsp4ve4m4u4ggk2pimednah2wa/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/.pnpm/sass-loader@10.4.1_sass@1.58.0_webpack@5.95.0/node_modules/sass-loader/dist/cjs.js!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.47_babel-core@7.0.0-bridge.0_@babel+core@7.20.12__cs_dsp4ve4m4u4ggk2pimednah2wa/node_modules/vue-loader/lib/index.js??vue-loader-options!./IconBase.vue?vue&type=style&index=0&id=66905850&prod&lang=scss&scoped=true";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};